export interface WYSIWYGData {
  content: string
}

export const initialWYSIWYGData: WYSIWYGData = {
  content: ''
}
